import { Icon } from "@iconify/react";
import appleFilled from "@iconify/icons-ant-design/apple-filled";
// material
import { alpha, styled } from "@mui/material/styles";
import { Card, Typography } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// utils
import { fNumber, fShortenNumber } from "../../../utils/formatNumber";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  textAlign: "center",
  padding: theme.spacing(5, 0),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.info.lighter,
}));

const IconWrapperStyle = styled("div")(({ theme }) => ({
  margin: "auto",
  display: "flex",
  borderRadius: "50%",
  alignItems: "center",
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: "center",
  marginBottom: theme.spacing(3),
  color: theme.palette.info.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(
    theme.palette.info.dark,
    0
  )} 0%, ${alpha(theme.palette.info.dark, 0.24)} 100%)`,
}));

// ----------------------------------------------------------------------

const TOTAL = "$131";

export default function AppNewUsers({ count }) {
  return (
    <RootStyle>
      <IconWrapperStyle>
        <CurrencyPoundIcon />
        {/* <Icon icon={appleFilled} width={24} height={24} /> */}
      </IconWrapperStyle>
      <Typography variant="h4">
        £
        {count?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Pending Commission
      </Typography>
    </RootStyle>
  );
}
